export default class NumberFormatter {
    static toCurrency(number = 0) {
        const num = parseInt(NumberFormatter.removeThousandSeparators(number), 10);
        return `${NumberFormatter.toThousandSeparated(num)} Ft`;
    }

    static toThousandSeparated(number) {
        return NumberFormatter.removeThousandSeparators(number)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    static removeThousandSeparators(number) {
        return String(number).replace(/\s/g, '');
    }

    static bankAccount(number) {
        if (number[number.length - 1] !== '-') {
            // eslint-disable-next-line no-useless-escape
            const pureNumber = number.replace(/\-/g, '');
            let formatted = '';

            for (let i = 0; i < pureNumber.length; i += 1) {
                if (i < 24) {
                    if (i > 0 && i % 8 === 0) {
                        formatted += '-';
                    }
                    formatted += pureNumber[i];
                }
            }

            return formatted;
        }
        return number;
    }
}
